import restApi from '../../http-common'
// import swal from 'sweetalert2'
import VueRouter from 'vue-router'
import swal from "sweetalert2";
import session from "../../services/session";
import CONFIG_COMPANY from "../../services/myConfig";
import COMPANIES from "../../services/ListCompany";
import Loc from "../../services/localization";
import AdminApi from "../../services/api";
import BASE_API from "../../services/BaseApi";

const router = new VueRouter();
const apiService = new AdminApi();
const LocService = new Loc()

export default {
    name: 'login',
    data() {
        return {
            locale: LocService,
            backendError: null,
            companiesList : [],
            companyName: CONFIG_COMPANY.NAME,
            selectedCompany: null,
            model: {
                email: '',
                password: ''
            },
            // logoImage: require('../../assets/img/cfns_logo.png')
            logoImage: null//require('../../assets/img/cfns_logo.png')
        }
    },
    methods: {
        detectAgent:detectAgent,
        getConfig:getConfig,
        getCompanyList:getCompanyList,

        onTextChange(){
            this.backendError = null
        },

        keymonitor(event) {
            if(event.key === 'Enter') {
                this.login();
            }
        },

        login() {
            let app = this;
            apiService.signIn(app.model)
                .then((response) => {
                    if (response.status === 200 && 'accessToken' in response.data) {
                        localStorage.setItem('ACCESS_TOKEN', response.data.accessToken);
                        localStorage.setItem('USER_ROLE', response.data.role);
                        localStorage.setItem('USERNAME', response.data.username);
                        localStorage.setItem('REST_OF_TRAININGS', response.data.restOfTrainings);
                        localStorage.setItem('GYM', response.data.gym);
                        localStorage.setItem('IS_MAIN_ADMIN', response.data.isMainAdmin);
                        if(response.data.isAcceptedTerms){
                            app.$router.push(CONFIG_COMPANY.HOME);
                        }else {
                            swal('Upozorenje', 'Morate da prihvatite uslove korišćenja ukoliko želite da trenirate.', 'warning');
                            window.location = '/#/accept-terms';
                        }
                    }
                })
                .catch((error) => {
                    // swal('Error', error, 'error')
                });
        }
    },
    components: {},
    watch: {
        'selectedCompany': function (newVal) {
            if(newVal != null){
                CONFIG_COMPANY.setCompany(newVal.name)
                this.companyName = CONFIG_COMPANY.NAME
            }
            this.logoImage = BASE_API + 'company-image/'+ newVal.name;
            this.getConfig(true);
        }
    },
    beforeMount() {
        if(localStorage.getItem('ACCESS_TOKEN') != null && localStorage.getItem('ACCESS_TOKEN').length > 0){
            this.$router.push(CONFIG_COMPANY.HOME);
        }
        this.logoImage = BASE_API + 'company-image/'+CONFIG_COMPANY.NAME;

        this.getConfig(true);
        this.getCompanyList();
    },
    created() {

    }
}

function detectAgent() {
    if(!this.showDialogApp) return;
    let androidUrl = session.getConfig().googlePlay;
    let aAndroid = '<a href=\"' + androidUrl +'\">';
    let iosUrl = session.getConfig().appStore;
    let aios = '<a href=\"' + iosUrl +'\">';
    if(navigator.userAgent.toString().includes("Android")){
        swal({
            title: LocService.t("label_download_app"),
            html : '<html><div class="foo">' +
                '<br>' +
                aAndroid +
                '<div class="dialog-google-play"></div>'+
                '</a>' +
                '<br>'+
                // '<a><u>Ne sada</u></a>'+
                '</div></html>',
            text: "",
            showCancelButton: false,
            showConfirmButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: LocService.t("label_not_now"),
            customClass: 'swal2-warning'
        }).then(function () {

        });
    }else if(navigator.userAgent.toString().includes("iPhone")){
        swal({
            title: LocService.t("label_download_app"),
            html : '<html><div class="foo">' +
                '<br>' +
                aios +
                '<div class="dialog-app-store"></div>'+
                '</a>' +
                '<br>'+
                // '<a><u>Ne sada</u></a>'+
                '</div></html>',
            text: "",
            showCancelButton: false,
            showConfirmButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: LocService.t("label_not_now"),
            customClass: 'swal2-warning'
        }).then(function () {

        });
    }
}

function getConfig(force){
    if(!session.shouldFetchConfig() && force === false) {
        this.showDialogApp = session.getConfig().shouldAskToDownloadApps
        this.detectAgent()
        return;
    }
    let _self = this;
    apiService.getCompanyConfiguration(CONFIG_COMPANY.NAME)
        .then((response) => {
            session.saveConfig(response.data)
            session.setLastFetchConfig();
            _self.showDialogApp = session.getConfig().shouldAskToDownloadApps
            _self.detectAgent()
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function getCompanyList(){
    let _self = this;
    apiService.getCompanyList(CONFIG_COMPANY.NAME)
        .then((response) => {
            _self.companiesList = response.data;
            if(_self.companiesList.length > 0){
                _self.selectedCompany = _self.companiesList[0]
            }
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}



// WEBPACK FOOTER //
// ./src/components/Account/Login.js